import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faRedo, faSpinner } from '@fortawesome/free-solid-svg-icons';
import {
  getInstallmentSimulation,
  INSTALLMENT_UPDATE_FAILURE,
  INSTALLMENT_UPDATE_SUCCESS,
  updateInstallment,
} from '../../../../store/actions/customer-actions';
import { findCurrentLoanRePayments } from '../../../../store/actions/loan-actions';
import { hideEmailPartially } from '../../../../utils/helper/formatting';
import { ModalPaymentContainer } from './modal-payment-container';
import ErrorNotification from '../../../../components/features/error-notification/error-notification';
import { SpinnerIcon } from '../icons';
import './modal-anticipation.scss';
import Button from '../../../../components/UI/button/button';

function ModalAnticipation({
  onClose,
  installment,
  closeModalFunction,
  onModalAlertChange,
  getInstallmentSimulation,
  updateInstallment,
  findCurrentLoanRePayments,
  device,
  loan,
  errors,
  installmentSimulation,
}) {
  const [loading, setLoading] = useState(false);
  const [loadingConfirmUpdate, setLoadingConfirmUpdate] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [splitDueDate, setSplitDueDate] = useState('');

  useEffect(() => {
    setSplitDueDate(installmentSimulation ? installmentSimulation.dueDate.split('-') : 'xxxx-xx-xx');
  }, [installmentSimulation]);

  useEffect(() => {
    if (loan && installment) {
      setLoading(true);
      const today = new Date();
      const month = (today.getMonth() + 1).toLocaleString('pt-BR', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });

      const day = today.getDate();
      const year = today.getFullYear();
      const todayFormatted = `${day}/${month}/${year}`;

      getInstallmentSimulation(installment?.number, todayFormatted, device).then((response) => {
        setLoading(false);
      });
    }
  }, [loan, installment, device, getInstallmentSimulation]);

  const confirmUpdateInstallment = () => {
    setLoadingConfirmUpdate(true);

    if (loan && loan?.id && installment) {
      const today = new Date();
      const month = (today.getMonth() + 1).toLocaleString('pt-BR', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      const day = today.getDate();
      const year = today.getFullYear();
      const todayFormatted = `${day}/${month}/${year}`;

      updateInstallment(installment.number, todayFormatted, device).then((response) => {
        setLoadingConfirmUpdate(false);
        if (response.type === INSTALLMENT_UPDATE_SUCCESS) {
          closeModalFunction();
          findCurrentLoanRePayments();
          onModalAlertChange(
            true,
            `Boleto enviado para ${hideEmailPartially(loan?.application?.personal?.emailAddress)}.`,
            'Sucesso!',
          );
        } else if (response.type === INSTALLMENT_UPDATE_FAILURE) {
          setErrorMessage('Antecipação não disponível');
        }
      });
    }
  };

  return (
    <ModalPaymentContainer
      headerTitle="Antecipação de parcela"
      onClose={onClose}
      icon={<FontAwesomeIcon icon={faRedo} size="4x" />}
    >
      <div>
        <ErrorNotification errors={errors} />
        {!loading && installmentSimulation ? (
          <div className="modal-anticipation-content center">
            {installmentSimulation && (
              <div>
                <div style={{ color: 'black' }}>
                  <div className="block-large">
                    <h1 className="text-1 highlight bold center">
                      <b>Atenção!</b>
                    </h1>
                  </div>
                  <p>
                    O valor para pagamento antecipado da parcela <b>{installmentSimulation.number}</b> é de:
                  </p>
                  <div className="block-large">
                    <div>
                      <b>Valor: R$ {installmentSimulation.owedAmount.toString().replace('.', ',')}</b>
                    </div>
                    <div>
                      <b>Vencimento: {`${splitDueDate[2]}/${splitDueDate[1]}/${splitDueDate[0]}`}</b>
                    </div>
                  </div>
                  <p>Ao confirmar a antecipação o boleto será gerado e enviado por email.</p>
                </div>
                <div style={{ color: '#FF4F50', fontSize: '10px' }} className="block-large">
                  <b>
                    A antecipação não pode ser desfeita e o boleto deverá ser pago no vencimento para não atrasar a
                    parcela.
                  </b>
                </div>
                <div className="py-4">
                  <a style={{ fontSize: '15px' }}>
                    <Button
                      style={{ height: '39px' }}
                      className="button-primary anticipation-button"
                      onClick={confirmUpdateInstallment}
                    >
                      {loadingConfirmUpdate ? (
                        <FontAwesomeIcon icon={faSpinner} className="loading" style={{ margin: '0' }} />
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                          Confirmar antecipação
                        </>
                      )}
                    </Button>
                  </a>
                </div>
                {errorMessage && <div className="modal-anticipation-error-message">{errorMessage}</div>}
              </div>
            )}
          </div>
        ) : (
          <div className="modal-slip-options-loading">
            <SpinnerIcon className="loading" />
          </div>
        )}
      </div>
    </ModalPaymentContainer>
  );
}

const mapStateToProps = (state) => ({
  device: state.customer.device,
  loan: state.personalLending.loan,
  errors: state.customer.errors,
  installmentSimulation: state.customer.installmentSimulation,
});

const mapDispatchToProps = (dispatch) => ({
  getInstallmentSimulation: (installmentNumber, date, device) =>
    dispatch(getInstallmentSimulation(installmentNumber, date, device)),
  updateInstallment: (installmentNumber, date, device) =>
    dispatch(updateInstallment(installmentNumber, date, device)),
  findCurrentLoanRePayments: (device) => dispatch(findCurrentLoanRePayments(device)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalAnticipation);
